import React from 'react';
import {Link} from "react-router-dom";

interface Technology {
    Version?: string;
    TechnologyURL?: string;
    Technology?: string;
}

interface VersionRefProps {
    technology: Technology;
}

export default function VersionRef({technology}: VersionRefProps) {
    if (!technology.Version) return null;
    if (!technology.TechnologyURL) return null;

	return (
        <Link 
            to = {`/technology/${technology.TechnologyURL}/version/${technology.Version}/websites`}
            className="link-hover"
            title={`${technology.Technology} version ${technology.Version}`}
        >
            {technology.Version}
        </Link>    
    );
}
